var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"response-list"},[_c('card-collapse-list',{attrs:{"title":_vm.responsesTitle}},[_c('response-list',{attrs:{"assignments":_vm.assignments}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }